import { RootState } from '../../model/model'

export const selectTimeouts = (state: RootState) => state.timeouts
